var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraserBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.42 22.84C18.1748 22.84 22.84 18.1748 22.84 12.42C22.84 6.66519 18.1748 2 12.42 2C6.66519 2 2 6.66519 2 12.42C2 18.1748 6.66519 22.84 12.42 22.84Z",
    stroke: "#5F5F5F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4614 5.58589L5.63819 15.126C5.25195 15.8899 5.55815 16.8223 6.32211 17.2086L12.2835 20.2225C13.0475 20.6087 13.9799 20.3025 14.3661 19.5386L19.1893 9.99852C19.5756 9.23457 19.2694 8.30215 18.5054 7.91591L12.544 4.90197C11.78 4.51573 10.8476 4.82194 10.4614 5.58589Z",
    fill: "#71BAE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.29 20.22L6.32001 17.2C5.56001 16.81 5.25001 15.88 5.64001 15.12L8.94001 8.58L17.67 12.99L14.37 19.53C13.98 20.29 13.05 20.6 12.29 20.21V20.22Z",
    fill: "#D1D3D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62175 7.2676L8.58401 9.32019L17.312 13.7328L18.3497 11.6802L9.62175 7.2676Z",
    fill: "#4D9ED6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserBig);
export default __webpack_public_path__ + "static/media/eraser-big.dad26b9c594d6989096c3854f873eb85.svg";
export { ForwardRef as ReactComponent };